const resetHandlers = new Set<() => void>()
const expirationHandlers = new Set<() => void>()
let authorityEpoch = 0

export function authContextEpoch(): number {
  return authorityEpoch
}

export function onAuthContextChanged(handler: () => void): () => void {
  resetHandlers.add(handler)

  return () => resetHandlers.delete(handler)
}

export function replaceAuthContext(): void {
  authorityEpoch += 1
  for (const handler of resetHandlers) handler()
}

export function onAuthSessionExpired(handler: () => void): () => void {
  expirationHandlers.add(handler)

  return () => expirationHandlers.delete(handler)
}

export function expireAuthSession(): void {
  replaceAuthContext()
  for (const handler of expirationHandlers) handler()
}

interface AuthIdentitySource {
  api?: unknown
  userData?: unknown
  role?: unknown
  headers?: unknown
}

interface AuthAuthoritySource extends AuthIdentitySource {
  token?: unknown
  permissions?: unknown
}

/** Tenant, actor, role and credential headers: the identity a page's data belongs to. */
export function authIdentity(source: AuthIdentitySource): string {
  const actor = (source.userData as { userGUID?: unknown } | null | undefined)?.userGUID

  return JSON.stringify([source.api, actor, source.role, source.headers])
}

/** The identity plus the token and permissions that authorize requests made under it. */
export function authAuthority(source: AuthAuthoritySource): string {
  return JSON.stringify([authIdentity(source), source.token, source.permissions])
}
